module.exports = __webpack_public_path__ + "img/Webflow_logo_2023.cc7906fb.svg";